module.exports = __webpack_public_path__ + "img/2f_r_horse@2x.eefc148b.png";